import { Experiment } from '@mc/experiments-react'
import { Hero as HeroVariant } from './components/Hero'
import { GIFT_PAGE_REDESIGN_FLAG_NAME } from './constants'

export const GiftPageRedesingExperiment = ({
  control,
}: {
  control: React.ReactNode
}) => (
  <Experiment
    name={GIFT_PAGE_REDESIGN_FLAG_NAME}
    control={() => control}
    variant_1={() => <HeroVariant />}
  />
)
